import { Injectable } from '@angular/core';

@Injectable()
export class FlashMessageService {

  constructor() { }

  showMessage = false;
  message = '';
  cssClass = '';

  updateMessage(message: string, timeout = 2000, cssClass: string = 'danger') {
    this.message = message;
    this.cssClass = cssClass;
    this.showMessage = true;
    return new Promise((resolve) => {
      setTimeout(() => {
        this.showMessage = false;
        this.message = '';
        resolve();
      }, timeout);
    })
  }
}

